export const chatConfigs = {
  messagePerPage: 10,
  chatBasePath: '/messaging/tickets/ticket_',
  chatConstant: '/100',
  chatMessages: '/messages',
  chatUserPath: '/users/'
};
